// All user related database operations can be defined here.

import {
  VERIFY_ENROL_LINK,
  RESENDONETIMECODE,
  VERIFYONETIMECODE,
  SENDMAGICLINK,
  VERIFYMAGICLINK,
  SELECTACCOUNT
} from "./CONSTANTS";
import http from "../http-common";

class LoginDataService {
  verifyEnrolLink(code: string) {
    return http.get(VERIFY_ENROL_LINK(code));
  }
  resendOneTimeCode(phoneId: string) {
    return http.post(RESENDONETIMECODE, { phoneId });
  }
  sendMagicLink(email: string) {
    return http.post(SENDMAGICLINK, { email });
  }
  verifyMagicLink(token: string) {
    return http.post(VERIFYMAGICLINK, { token });
  }
  verifyOneTimeCode(
    phoneId: string,
    code: string,
    token: string
  ) {
    return http.post(VERIFYONETIMECODE, { phoneId, code, token });
  }
  selectAccount(userId:string) {
    return http.post(SELECTACCOUNT, { userId })
  }
}

const dataservice = new LoginDataService();

export default dataservice;
